import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { LoadingFallback } from '@/components/ui/LoadingFallback';

interface ProtectedRouteProps {
    children: React.ReactNode;
    requireAdmin?: boolean;
    requirePremium?: boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requireAdmin = false, requirePremium = false }) => {
    const { user, loading, isAdmin, isPremium } = useAuth();

    if (loading) {
        return <LoadingFallback />;
    }

    if (!user) {
        return <Navigate to="/" replace />;
    }

    if (requireAdmin && !isAdmin) {
        return <Navigate to="/" replace />;
    }

    if (requirePremium && !isPremium) {
        return <Navigate to="/" replace />;
    }

    return <>{children}</>;
};
